import { AppRoute, MenuStage, NavigationLinkBase } from '@ebeihilfe/core';
import { Injectable } from '@angular/core';
import { marker as _ } from '@colsen1991/ngx-translate-extract-marker';

@Injectable()
export class NewAntragNavLink extends NavigationLinkBase {
  public readonly allowedStages = MenuStage.SIGNED_IN;

  constructor() {
    super('NEW_ANTRAG', _('menu.label.new_antrag'), AppRoute.EinreichungOld, _('a11y.link.einreichen'));
  }
}
